import React from 'react';
import { connect } from 'react-redux';
import { RootState } from 'reducers';
import { Table, Pagination, DatePicker, Button, Modal, Tooltip, Input, Select } from 'components';
import { CheckIcon, DeleteIcon, EditIcon, ExisIcon, PasswordInactive, PrinterIcon, SwitchOffIcon, SwitchOnIcon } from 'assets/icons';
import { AuthService, ClinicService, UserService } from 'services';
import moment from 'moment';
import ModalCreate from './modal-create';
import ModalRate from '../affiliate/modal-rate';
import ModalAddress from './modal-address';
import ModalViewSeller from './modal-view-seller'; // Importar el nuevo modal
import { Globals, Constants, Socket, SocketEvents, checkPermission } from 'utils';

const INITIAL_STATE = {
	since: '',
	until: '',
	search: '',
	status: '',
	state_id: '',
	city_id: '',
	level_id: Constants.LEVELS.SELLER,
	verification: '',
}

class Seller extends React.Component<any> {

	timer: any = undefined;

	state = {
		data: [],
		counter: {
			affiliates: 0,
			businesses: 0,
			clinics: 0,
			medics: 0,
			sellers: 0,
			users: 0,
		},
		page: 1,
		last_page: 1,
		header: [
			'Fecha',
			'Nombre o Denominación',
			'Documento',
			'Teléfono',
			'Correo',
			'Estado',
			'Ciudad',
			'Código',
			'Verificación',
			'Estatus',
			'Acción'
		],
		form: INITIAL_STATE,
		visible: false,
		item: null,
		visible_address: false,
		visible_rate: false,
		visible_view: false, // Nuevo estado para el modal de visualización
		cities: [],
	}

	componentDidMount() {
		this.load();
	}

	load = async (withoutLoading: boolean = false) => {
		const res: any = await UserService.admin.get({
			withoutLoading,
			page: this.state.page,
			...this.state.form,
			since: this.state.form.since && moment(this.state.form.since).format('YYYY-MM-DD'),
			until: this.state.form.until && moment(this.state.form.until).format('YYYY-MM-DD'),
		});
		this.setState({
			data: res.users.rows,
			counter: res.counter,
			last_page: res.users.count
		});
	}

	reset = () => {
		this.setState({
			form: INITIAL_STATE,
			page: 1
		}, () => this.load(true));
	}

	change = (e: any, callback = () => { }) => {
		this.setState({
			page: 1,
			form: {
				...this.state.form,
				[e.target.name]: e.target.value
			}
		}, callback);
	}

	getCities = async () => {
		const res: any = await AuthService.getCities({
			state_id: this.state.form.state_id,
		});
		this.setState({
			cities: res.cities,
		});
	};

	add = () => {
		this.setState({
			visible: true
		});
	}

	print = async () => {
		const res: any = await UserService.admin.get({
			page: this.state.page,
			...this.state.form,
			since: this.state.form.since && moment(this.state.form.since).format('YYYY-MM-DD'),
			until: this.state.form.until && moment(this.state.form.until).format('YYYY-MM-DD'),
			download: true,
		});

		if (res.url) {
			const link = document.createElement('a');
			link.href = res.url;
			link.download = res.url.split('/').pop();
			link.target = '_blank';
			link.click();
			link.remove();
		}
	}

	onClose = () => {
		this.setState({
			visible: false,
			item: null
		}, () => this.load(true));
	}

	onCloseRate = () => {
		this.setState({
			visible_rate: false,
			item: null
		}, () => this.load(true));
	}

	onCloseAddress = () => {
		this.setState({
			visible_address: false,
			item: null
		}, () => this.load(true));
	}

	// Nuevas funciones para el modal de visualización
	onCloseView = () => {
		this.setState({
			visible_view: false,
			item: null
		}, () => this.load(true));
	}

	viewSeller = (e: any, item: any) => {
		e.preventDefault();
		this.setState({
			visible_view: true,
			item
		});
	}

	approveOrRejectSeller = async (item: any, verification: number) => {
		const action = verification === Constants.USER.VERIFICATION.APPROVED ? 'aprobar' : 'rechazar';
		Globals.confirm(`¿Desea ${action} el registro de este vendedor/agente?`, async () => {
			try {
				await UserService.admin.approveOrReject({
					user_id: item.id,
					verification
				});

				this.setState({
					visible_view: false,
					item: null
				}, () => this.load(true));

				Socket.emit(SocketEvents.UPDATE_USER, {
					user_id: item.id
				});
			} catch (error) {
				console.error(`Error al ${action} vendedor:`, error);
			}
		});
	}

	delete = async (e: any, item: any) => {
		e.preventDefault();
		Globals.confirm('¿Desea eliminar la clínica?', async () => {
			await ClinicService.admin.delete({
				user_id: item.id
			});
			this.load(true);
			Socket.emit(SocketEvents.UPDATE_USER, {
				user_id: item.id
			});
		});
	}

	suspend = async (item: any) => {
		Globals.confirm(`¿Desea cambiar el estatus de la clínica a ${item.status == Constants.USER_STATUS.ACTIVE ? 'Suspendido' : 'Activo'}?`, async () => {
			await ClinicService.admin.suspend({
				user_id: item.id
			});
			this.load(true);
			Socket.emit(SocketEvents.UPDATE_USER, {
				user_id: item.id
			});
		});
	}

	edit = (e: any, item: any) => {
		e.preventDefault();
		this.setState({
			visible: true,
			item
		});
	}

	viewRate = (e: any, item: any) => {
		e.preventDefault();
		this.setState({
			visible_rate: true,
			item
		});
	}

	viewAddress = (e: any, item: any) => {
		e.preventDefault();
		this.setState({
			visible_address: true,
			item
		});
	}

	render() {
		const { counter, visible, visible_address, visible_rate, visible_view } = this.state;

		return (
			<div id="admin-register-clinic">
				<Modal
					className="modal-create-clinic"
					visible={visible}
					withoutClose={true}
					onClose={() => this.onClose()}
				>
					<ModalCreate
						states={this.props.states}
						document_types={this.props.document_types}
						phonecodes={this.props.phonecodes}
						item={this.state.item}
						onClose={() => this.onClose()}
					/>
				</Modal>

				<Modal
					className="modal-users-rate"
					visible={visible_rate}
					withoutClose={true}
					onClose={() => this.onCloseRate()}
				>
					{/*
					// @ts-ignore */}
					<ModalRate item={this.state.item} onClose={() => this.onCloseRate()} />
				</Modal>

				<Modal
					className="modal-users-address"
					visible={visible_address}
					withoutClose={true}
					onClose={() => this.onCloseAddress()}
				>
					<ModalAddress
						item={this.state.item}
						onClose={() => this.onCloseAddress()}
					/>
				</Modal>

				{/* Nuevo modal para visualizar vendedor/agente */}
				<Modal
					className="modal-view-seller"
					visible={visible_view}
					onClose={() => this.onCloseView()}
				>
					<ModalViewSeller
						item={this.state.item}
						states={this.props.states}
						onClose={() => this.onCloseView()}
						onApprove={(item) => this.approveOrRejectSeller(this.state.item, Constants.USER.VERIFICATION.APPROVED)}
						onReject={(item) => this.approveOrRejectSeller(this.state.item, Constants.USER.VERIFICATION.REJECTED)}
					/>
				</Modal>

				<div className="row row-filter mb-3" style={{ alignItems: 'flex-start' }}>
					{/* Buscar */}
					< div className="col-md-2">
						<Input
							value={this.state.form.search}
							name="search"
							label="Buscar por nombre"
							placeholder="Buscar"
							className="input-table"
							onChange={(e: any) => this.change(e)}
						/>
					</div>

					{/* Desde */}
					<div className="col-md-2" style={{ marginTop: '25px' }}>
						<DatePicker
							placeholder="Desde"
							onChange={(text: string) => {
								this.change(
									{
										target: {
											value: text,
											name: 'since',
										},
									},
								);
							}}
							value={this.state.form.since}
						/>
					</div>

					{/* Hasta */}
					<div className="col-md-2" style={{ marginTop: '25px' }}>
						<DatePicker
							placeholder="Hasta"
							onChange={(text: string) => {
								this.change(
									{
										target: {
											value: text,
											name: 'until',
										},
									}
								);
							}}
							value={this.state.form.until}
						/>
					</div>

					{/* Estatus */}
					<div className="col-md-2">
						<Select
							label="Estatus"
							name="status"
							onChange={(e: any) => this.change(e)}
							value={this.state.form.status}
							options={[
								{ value: Constants.USER_STATUS.ACTIVE.toString(), label: 'Activos' },
								{ value: Constants.USER_STATUS.INACTIVE.toString(), label: 'Suspendidos' },
							]}
						/>
					</div>

					{/* Estado */}
					<div className="col-md-2">
						<Select
							label="Estado"
							name="state_id"
							onChange={(e: any) =>
								this.change(e, () => {
									this.setState(
										{
											form: {
												...this.state.form,
												city_id: '',
											},
										},
										() => {
											this.getCities();   // cargar ciudades
										},
									);
								})
							}
							value={this.state.form.state_id}
							options={this.props.states.map((i: any) => ({
								value: i.id,
								label: i.name,
							}))}
						/>
					</div>

					{/* Ciudad */}
					<div className="col-md-2">
						<Select
							label="Ciudad"
							disabled={!this.state.form.state_id}
							name="city_id"
							onChange={(e: any) => this.change(e)}
							value={this.state.form.city_id}
							options={this.state.cities.map((i: any) => ({
								value: i.id,
								label: i.name,
							}))}
						/>
					</div>
					{/* Estatus de Verificación */}
					<div className="col-md-2">
						<Select
							label="Estatus de verificación"
							name="verification"
							onChange={(e: any) => this.change(e)}
							value={this.state.form.verification}
							options={[
								{ value: '0', label: 'En revisión' },
								{ value: '1', label: 'Verificado' },
								// { value: '2', label: 'Rechazado' },
							]}
						/>
					</div>

					{/* Limpiar */}
					<div className="col-md-3 filter-actions" style={{ marginTop: '18px' }}> {/* <-- CAMBIO AQUÍ: Ajuste visual */}
						<Button className="btn-filter" onClick={() => this.load(true)}>
							Filtrar
						</Button>

						{this.state.form !== INITIAL_STATE && (
							<Button className="btn-clean" onClick={this.reset}>
								Limpiar
							</Button>
						)}
					</div>
				</div>

				{this.props.tabs}

				<p className="text-right">Vendedores: { counter?.sellers || 0 }</p>

				<Table title="Historial de Registro" data={this.state.data.length} header={this.state.header} rightAlign={[10]} titleRight={
					<React.Fragment>
						{
							checkPermission(Constants.MODULES.REGISTER, 'write', this.props.user) && (
								<Button className="btn-add" onClick={() => this.print()}>
									<img src={PrinterIcon} alt="Descargar Excel" />
									Descargar Excel
								</Button>
							)
						}
					</React.Fragment>
				}>
					{this.state.data.map((i: any, index: number) => {
						const isUnderReview = i?.verification === Constants.USER.VERIFICATION.PENDING;

						return (
							<tr key={index}>
								<td>{moment(i.created_at).format('DD-MM-YYYY')}</td>
								<td>{i.name}</td>
								<td>{i.document_type?.name}{i.document}</td>
								<td>{i.phonecode?.name}-{i.phone}</td>
								<td>{i.email}</td>
								<td>{i?.state?.name}</td>
								<td>{i?.city?.name}</td>
								<td>{i.code}</td>
								<td>{i.verification_txt}</td>
								<td>{i.status_txt}</td>
								<td className="actions">
									{/* Botón Ver - usando el mismo icono de edición para mantener consistencia */}
									<Tooltip title="Ver">
										<a className="link-icon" href="#" onClick={(e: any) => this.viewSeller(e, i)}>
											<img src={PasswordInactive} alt="Ver" />
										</a>
									</Tooltip>

									{
										checkPermission(Constants.MODULES.REGISTER, 'write', this.props.user) && (
											<Tooltip title="Editar">
												<a className="link-icon" href="#" onClick={(e: any) => this.edit(e, i)}>
													<img src={EditIcon} />
												</a>
											</Tooltip>
										)
									}
									{
										checkPermission(Constants.MODULES.REGISTER, 'delete', this.props.user) && (
											<Tooltip title="Eliminar">
												<a className="link-icon" href="#" onClick={(e: any) => this.delete(e, i)}>
													<img src={DeleteIcon} />
												</a>
											</Tooltip>
										)
									}
									{(i?.verification === Constants.USER.VERIFICATION.APPROVED && checkPermission(Constants.MODULES.REGISTER, 'write', this.props.user)) && (
										<Tooltip title={i.status === Constants.USER_STATUS.ACTIVE ? 'Suspender' : 'Activar'}>
											<img
												style={{ width: 28, height: 28 }}
												src={i.status == Constants.USER_STATUS.ACTIVE ? SwitchOnIcon : SwitchOffIcon}
												onClick={() => this.suspend(i)}
												alt="Suspender/Activar"
											/>
										</Tooltip>
									)
									}
									{(checkPermission(Constants.MODULES.REGISTER, 'write', this.props.user) && isUnderReview) && (
										<Tooltip title="Aprobar">
											<a
												className="link-icon"
												href="#"
												onClick={(e: any) => {
													e.preventDefault();
													this.approveOrRejectSeller(i, Constants.USER.VERIFICATION.APPROVED)
												}}
											>
												<img src={CheckIcon} />
											</a>
										</Tooltip>
									)}
									{(checkPermission(Constants.MODULES.REGISTER, 'write', this.props.user) && isUnderReview) && (
										<Tooltip title="Rechazar">
											<a
												className="link-icon"
												href="#"
												onClick={(e: any) => {
													e.preventDefault();
													this.approveOrRejectSeller(i, Constants.USER.VERIFICATION.REJECTED)
												}}
											>
												<img src={ExisIcon} />
											</a>
										</Tooltip>
									)}
								</td>
							</tr>
						)
					})}
				</Table>

				<Pagination
					pages={this.state.last_page}
					active={this.state.page}
					onChange={async (page: number) => {
						await this.setState({
							page: page
						});
						this.load();
					}} />
			</div >
		)
	}
}

export default connect((state: RootState) => {
	return {
		user: state.user
	}
})(Seller);